export const CHAIN_TETRA = '662387';
